import {
  LIST_TIMESERIES_TYPES_REQUEST,
  LIST_TIMESERIES_TYPES_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'


// name -> {timeseries_type}
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_TIMESERIES_TYPES_REQUEST: {
      return {
        ...state,
        isLoading: true,
      }
    }
    case LIST_TIMESERIES_TYPES_RESPONSE: {
      const { isLoading, ...s } = state
      return {
        ...s,
        ...action.timeseriesTypes,
      }
    }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
